import React, {memo} from 'react';
import {Button, FacebookIcon} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import PrivacyPolicyButton, {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const Facebook = ({
  pending,
  privacyPolicyUrl,
  onClick,
}: {
  pending: boolean;
  onClick: (event: React.MouseEvent) => void;
} & PrivacyPolicyButtonProps) => {
  const {t} = useTranslation(['assetservices']);

  return (
    <>
      <Button
        onClick={onClick}
        label={!pending ? t('str_ButtonConnectToFacebook') : t('*:str_TitlePleaseWait')}
        buttonStyle={'distinct'}
        startIcon={<FacebookIcon />}
        disabled={pending}
      />
      <PrivacyPolicyButton privacyPolicyUrl={privacyPolicyUrl} />
    </>
  );
};

export default memo(Facebook);
